class VideoModal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    if (!this.els?.video?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    if (this.externalEls?.trigger?.selector) {
      document.addEventListener('click', this.handleTrigger)
    }

    if (this.els?.close?.selector) {
      document.addEventListener('click', this.handleClose)
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.externalEls.trigger.selector)
    if (!triggerEl) return

    const videoModalKey = event.target.dataset?.videoModalKey
    if (videoModalKey !== this.videoModalKey) return

    this.isOpen = true

    if (!this.els.source.element.src) {
      this.els.source.element.src = this.els.source.element.dataset.src
      this.els.video.element.load()
    }
    this.els.video.element.play()
  }

  handleClose (event) {
    const closeEl = event.target.closest(this.els.close.selector)
    if (!closeEl) return

    this.isOpen = false
    this.els.video.element.pause()
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (boolean) {
    this._isOpen = boolean

    this.setAttribute('aria-hidden', String(!boolean))
    this.hideWhenOpenEls?.forEach(hideWhenOpenEl => {
      hideWhenOpenEl.setAttribute('aria-hidden', String(boolean))
    })

    document.body.classList.toggle('lyt-ModalOpen', boolean)
  }

  get hideWhenOpenEls () {
    return this.externalEls?.['hide-when-open']?.elements.filter(
      hideWhenOpenEl =>
        hideWhenOpenEl.dataset?.videoModalKey === this.videoModalKey,
    )
  }

  get videoModalKey () {
    return this.dataset?.videoModalKey
  }
}

if (!customElements.get('video-modal')) {
  customElements.define('video-modal', VideoModal)
}
